export const IOS_APP_DOWNLOAD_URL = 'https://apps.apple.com/gb/app/space-nk-beauty/id6751544303';
export const ANDROID_APP_DOWNLOAD_URL = 'https://play.google.com/store/apps/details?id=com.spacenk.prd';

export type AppPromoDownloadUrls = {
    iosAppDownloadUrl?: string;
    androidAppDownloadUrl?: string;
};

export function getAppDownloadUrl(userAgent: string, urls?: AppPromoDownloadUrls): string {
    const isIOS = /iPad|iPhone|iPod/i.test(userAgent) || (/Macintosh/i.test(userAgent) && /Mobile/i.test(userAgent));
    if (isIOS) {
        return urls?.iosAppDownloadUrl || IOS_APP_DOWNLOAD_URL;
    }
    return urls?.androidAppDownloadUrl || ANDROID_APP_DOWNLOAD_URL;
}
